import { Box, Card, Divider, Grid, Typography } from "@mui/material";
import EditAccountForm from "./edit-acount.form";

export default function Account() {
    return(
        <>
            <Box mt={3} mb={1}>
                <Typography variant="h4" fontWeight={700} sx={{ color: 'primary.main', letterSpacing: 1 }}>
                    Utilizador
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                    Configurações e dados da tua conta
                </Typography>
                <Divider sx={{ mt: 2, borderColor: 'rgba(255,215,0,0.15)' }} />
            </Box>
            <Card sx={{ mt: 2, border: '1px solid rgba(255,215,0,0.15)' }}>
                <EditAccountForm />
            </Card>
        </>
    )
}